<template lang="pug">
div(v-if='resultados.length === 0')
    span.nao-ha-restricoes Não há restrições!
div(v-else)
    .item-info(v-for='resultado in resultados')
        div
            .item-info-crosshairs-gps-icon(
                v-if='mapaLeaflet && possuiGeometria(resultado)',
                @click='aplicarZoomGeoJson(resultado)'
            )
                i.mdi.mdi-crosshairs-gps
            .info-resultado(v-if='resultado.properties?.ano || resultado.ano')
                label Ano:
                span {{ resultado.properties?.ano || resultado.ano }}
            .info-resultado(
                v-if='resultado.properties?.ano_acao_fiscal || resultado.ano_acao_fiscal'
            )
                label Ano da ação fiscal:
                span {{ resultado.properties?.ano_acao_fiscal || resultado.ano_acao_fiscal }}
            .info-resultado(
                v-if='resultado.properties?.dano || resultado.dano'
            )
                label Dano:
                span {{ resultado.properties?.dano || resultado.dano }}
            .info-resultado(
                v-if='resultado.properties?.tipo || resultado?.tipo'
            )
                label Tipo:
                span {{ resultado.properties?.tipo || resultado?.tipo }}
            .info-resultado(
                v-if='resultado.properties?.cultura || resultado.cultuta'
            )
                label Cultura plantada:
                span {{ resultado.properties?.cultura || resultado.cultura }}
            .info-resultado(
                v-if='resultado.properties?.nome || resultado.nome'
            )
                label Nome:
                span {{ resultado.properties?.nome || resultado.nome }}
            .info-resultado(
                v-if='resultado.properties?.codigo_cnuc || resultado.codigo_cnuc'
            )
                label Código CNUC:
                span {{ resultado.properties?.codigo_cnuc || resultado.codigo_cnuc }}
            .info-resultado(
                v-if='resultado.properties?.areaHa || resultado.areaHa'
            )
                label Área (ha):
                span {{ formatArea(resultado.properties?.areaHa || resultado.areaHa, 2) || '-' }}
            .info-resultado(
                v-if='resultado.properties?.percentualSobreposicaoGeometria || resultado.percentualSobreposicaoGeometria'
            )
                label Percentual de sobreposição (ha):
                span {{ getPercentualSobreposicaoGeometriaFormatado(resultado.properties?.percentualSobreposicaoGeometria || resultado.percentualSobreposicaoGeometria, 2) }}
            .info-resultado(
                v-if='resultado.properties?.fazenda || resultado.fazenda'
            )
                label Fazenda:
                span {{ resultado.properties?.fazenda || resultado.fazenda }}
            .info-resultado(
                v-if='resultado.properties?.estabelecimento || resultado.estabelecimento'
            )
                label Estabelecimento:
                span {{ resultado.properties?.estabelecimento || resultado.estabelecimento }}
            .info-resultado(
                v-if='resultado.properties?.proprietario || resultado.proprietario'
            )
                label Proprietário:
                span {{ resultado.properties?.proprietario || resultado.proprietario }}
            .info-resultado(
                v-if='resultado.properties?.empregador || resultado.empregador'
            )
                label Empregador:
                span {{ resultado.properties?.empregador || resultado.empregador }}
            .info-resultado(
                v-if='resultado.properties?.cpf_cnpj || resultado.cpf_cnpj'
            )
                label CPF/CNPJ:
                span {{ formatCpfCnpj(resultado.properties?.cpf_cnpj || resultado.cpf_cnpj) || '-' }}
            .info-resultado(
                v-if='resultado.properties?.descricao || resultado.descricao'
            )
                label Descrição:
                span {{ resultado.properties?.descricao || resultado.descricao }}

            .info-resultado(
                v-if='resultado.properties?.cnae || resultado.cnae'
            )
                label CNAE:
                span {{ resultado.properties?.cnae || resultado.cnae }}
            .info-resultado(v-if='resultado.properties?.uf || resultado.uf')
                label UF:
                span {{ resultado.properties?.uf || resultado.uf }}
            .info-resultado(
                v-if='resultado.properties?.latitude || resultado.latitude'
            )
                label Latitude:
                span {{ resultado.properties?.latitude || resultado.latitude }}
            .info-resultado(
                v-if='resultado.properties?.longitude || resultado.longitude'
            )
                label Longitude:
                span {{ resultado.properties?.longitude || resultado.longitude }}
            .info-resultado(v-if='resultado.mensagem')
                span {{ resultado.mensagem }}
</template>

<script>
import formatter from '@/utils/formatters.js';

export default {
    name: 'InformacoesRestricao',

    props: {
        resultados: {
            type: Array,
            required: true
        },
        mapaLeaflet: {
            type: Object,
            required: false
        }
    },

    methods: {
        formatArea(value, decimalPlaces = 2) {
            return formatter.maxFormatNumber(value, decimalPlaces);
        },

        getPercentualSobreposicaoGeometriaFormatado(
            percentual,
            decimalPlaces = 2
        ) {
            const percent = formatter.maxFormatNumber(
                percentual,
                decimalPlaces
            );
            return percent !== '-' ? percent + '%' : percent;
        },

        formatCpfCnpj(cpfCnpj) {
            return formatter.numeralStringFormatTocpfCnpj(cpfCnpj);
        },

        aplicarZoomGeoJson(resultado) {
            const geometria = resultado.geometria || resultado.geometry;
            this.mapaLeaflet.aplicarZoomGeoJson(geometria);
        },

        possuiGeometria(resultado) {
            return (
                resultado.geometria ||
                resultado.geometry ||
                (resultado.properties?.latitude &&
                    resultado.properties?.longitude)
            );
        }
    }
};
</script>

<style lang="scss">
.nao-ha-restricoes {
    padding-left: 7px;
}

.item-info {
    border: 1px solid $default-border-color;
    background-color: $white;
    padding: 12px;
    border-radius: $default-border-radius;
}

.item-info-crosshairs-gps-icon {
    width: 40px;
    height: 35px;
    background-color: $selected-background-color;
    border-radius: $default-border-radius;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $default-border-color;
    margin-bottom: 10px;
}

.info-resultado {
    display: flex;
    gap: 5px;
    overflow-x: scroll;
}

.info-resultado label {
    font-weight: bold;
}
</style>
